// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleNotice__b10 {
  color: var(--ring-secondary-color);
  font-size: var(--ring-font-size-smaller);
  line-height: var(--ring-line-height-lowest);
  margin-top: calc(var(--ring-unit) / 2);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/common/forms/jetbrains-ai-provider-form/jetbrains-ai-provider-form.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;EAC3C,sCAAsC;AACxC","sourcesContent":[".toggleNotice {\n  color: var(--ring-secondary-color);\n  font-size: var(--ring-font-size-smaller);\n  line-height: var(--ring-line-height-lowest);\n  margin-top: calc(var(--ring-unit) / 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleNotice": `toggleNotice__b10`
};
export default ___CSS_LOADER_EXPORT___;
